/* eslint-disable */
import Long from "long";
import _m0 from "protobufjs/minimal";
import { Timestamp } from "../google/protobuf/timestamp";

export const protobufPackage = "Reality.Reality.Api";

export enum AgencyEventType {
  AGENCY_EVENT_TYPE_UNKNOWN = 0,
  AGENCY_EVENT_TYPE_INDIVIDUAL = 1,
  AGENCY_EVENT_TYPE_GROUP = 2,
  UNRECOGNIZED = -1,
}

export function agencyEventTypeFromJSON(object: any): AgencyEventType {
  switch (object) {
    case 0:
    case "AGENCY_EVENT_TYPE_UNKNOWN":
      return AgencyEventType.AGENCY_EVENT_TYPE_UNKNOWN;
    case 1:
    case "AGENCY_EVENT_TYPE_INDIVIDUAL":
      return AgencyEventType.AGENCY_EVENT_TYPE_INDIVIDUAL;
    case 2:
    case "AGENCY_EVENT_TYPE_GROUP":
      return AgencyEventType.AGENCY_EVENT_TYPE_GROUP;
    case -1:
    case "UNRECOGNIZED":
    default:
      return AgencyEventType.UNRECOGNIZED;
  }
}

export function agencyEventTypeToJSON(object: AgencyEventType): string {
  switch (object) {
    case AgencyEventType.AGENCY_EVENT_TYPE_UNKNOWN:
      return "AGENCY_EVENT_TYPE_UNKNOWN";
    case AgencyEventType.AGENCY_EVENT_TYPE_INDIVIDUAL:
      return "AGENCY_EVENT_TYPE_INDIVIDUAL";
    case AgencyEventType.AGENCY_EVENT_TYPE_GROUP:
      return "AGENCY_EVENT_TYPE_GROUP";
    case AgencyEventType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * <strong>POST /api/v2/agency_event/ranking/get_event</strong>
 * 事務所イベント情報を取得
 */
export interface AgencyEventRankingGetEventRequest {
  /** @deprecated */
  eventId: number;
  eventKey: string;
}

export interface AgencyEventRankingGetEventResponse {
  id: number;
  name: string;
  startAt: Date | undefined;
  endAt: Date | undefined;
  headerUrl: string;
  description: string;
  isDisplayDisclaimer: boolean;
  eventType: AgencyEventType;
  /** グループ内スコア加算無効フラグ */
  isGroupInnerScoreDisabled: boolean;
}

function createBaseAgencyEventRankingGetEventRequest(): AgencyEventRankingGetEventRequest {
  return { eventId: 0, eventKey: "" };
}

export const AgencyEventRankingGetEventRequest = {
  encode(message: AgencyEventRankingGetEventRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.eventId !== 0) {
      writer.uint32(8).int64(message.eventId);
    }
    if (message.eventKey !== "") {
      writer.uint32(18).string(message.eventKey);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgencyEventRankingGetEventRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgencyEventRankingGetEventRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.eventId = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.eventKey = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgencyEventRankingGetEventRequest {
    return {
      eventId: isSet(object.eventId) ? globalThis.Number(object.eventId) : 0,
      eventKey: isSet(object.eventKey) ? globalThis.String(object.eventKey) : "",
    };
  },

  toJSON(message: AgencyEventRankingGetEventRequest): unknown {
    const obj: any = {};
    if (message.eventId !== 0) {
      obj.eventId = Math.round(message.eventId);
    }
    if (message.eventKey !== "") {
      obj.eventKey = message.eventKey;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgencyEventRankingGetEventRequest>, I>>(
    base?: I,
  ): AgencyEventRankingGetEventRequest {
    return AgencyEventRankingGetEventRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgencyEventRankingGetEventRequest>, I>>(
    object: I,
  ): AgencyEventRankingGetEventRequest {
    const message = createBaseAgencyEventRankingGetEventRequest();
    message.eventId = object.eventId ?? 0;
    message.eventKey = object.eventKey ?? "";
    return message;
  },
};

function createBaseAgencyEventRankingGetEventResponse(): AgencyEventRankingGetEventResponse {
  return {
    id: 0,
    name: "",
    startAt: undefined,
    endAt: undefined,
    headerUrl: "",
    description: "",
    isDisplayDisclaimer: false,
    eventType: 0,
    isGroupInnerScoreDisabled: false,
  };
}

export const AgencyEventRankingGetEventResponse = {
  encode(message: AgencyEventRankingGetEventResponse, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.id !== 0) {
      writer.uint32(8).int64(message.id);
    }
    if (message.name !== "") {
      writer.uint32(18).string(message.name);
    }
    if (message.startAt !== undefined) {
      Timestamp.encode(toTimestamp(message.startAt), writer.uint32(26).fork()).ldelim();
    }
    if (message.endAt !== undefined) {
      Timestamp.encode(toTimestamp(message.endAt), writer.uint32(34).fork()).ldelim();
    }
    if (message.headerUrl !== "") {
      writer.uint32(42).string(message.headerUrl);
    }
    if (message.description !== "") {
      writer.uint32(50).string(message.description);
    }
    if (message.isDisplayDisclaimer === true) {
      writer.uint32(56).bool(message.isDisplayDisclaimer);
    }
    if (message.eventType !== 0) {
      writer.uint32(64).int32(message.eventType);
    }
    if (message.isGroupInnerScoreDisabled === true) {
      writer.uint32(72).bool(message.isGroupInnerScoreDisabled);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): AgencyEventRankingGetEventResponse {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAgencyEventRankingGetEventResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.id = longToNumber(reader.int64() as Long);
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.name = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.startAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.endAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.headerUrl = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.description = reader.string();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.isDisplayDisclaimer = reader.bool();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.eventType = reader.int32() as any;
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.isGroupInnerScoreDisabled = reader.bool();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AgencyEventRankingGetEventResponse {
    return {
      id: isSet(object.id) ? globalThis.Number(object.id) : 0,
      name: isSet(object.name) ? globalThis.String(object.name) : "",
      startAt: isSet(object.startAt) ? fromJsonTimestamp(object.startAt) : undefined,
      endAt: isSet(object.endAt) ? fromJsonTimestamp(object.endAt) : undefined,
      headerUrl: isSet(object.headerUrl) ? globalThis.String(object.headerUrl) : "",
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      isDisplayDisclaimer: isSet(object.isDisplayDisclaimer) ? globalThis.Boolean(object.isDisplayDisclaimer) : false,
      eventType: isSet(object.eventType) ? agencyEventTypeFromJSON(object.eventType) : 0,
      isGroupInnerScoreDisabled: isSet(object.isGroupInnerScoreDisabled)
        ? globalThis.Boolean(object.isGroupInnerScoreDisabled)
        : false,
    };
  },

  toJSON(message: AgencyEventRankingGetEventResponse): unknown {
    const obj: any = {};
    if (message.id !== 0) {
      obj.id = Math.round(message.id);
    }
    if (message.name !== "") {
      obj.name = message.name;
    }
    if (message.startAt !== undefined) {
      obj.startAt = message.startAt.toISOString();
    }
    if (message.endAt !== undefined) {
      obj.endAt = message.endAt.toISOString();
    }
    if (message.headerUrl !== "") {
      obj.headerUrl = message.headerUrl;
    }
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.isDisplayDisclaimer === true) {
      obj.isDisplayDisclaimer = message.isDisplayDisclaimer;
    }
    if (message.eventType !== 0) {
      obj.eventType = agencyEventTypeToJSON(message.eventType);
    }
    if (message.isGroupInnerScoreDisabled === true) {
      obj.isGroupInnerScoreDisabled = message.isGroupInnerScoreDisabled;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AgencyEventRankingGetEventResponse>, I>>(
    base?: I,
  ): AgencyEventRankingGetEventResponse {
    return AgencyEventRankingGetEventResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AgencyEventRankingGetEventResponse>, I>>(
    object: I,
  ): AgencyEventRankingGetEventResponse {
    const message = createBaseAgencyEventRankingGetEventResponse();
    message.id = object.id ?? 0;
    message.name = object.name ?? "";
    message.startAt = object.startAt ?? undefined;
    message.endAt = object.endAt ?? undefined;
    message.headerUrl = object.headerUrl ?? "";
    message.description = object.description ?? "";
    message.isDisplayDisclaimer = object.isDisplayDisclaimer ?? false;
    message.eventType = object.eventType ?? 0;
    message.isGroupInnerScoreDisabled = object.isGroupInnerScoreDisabled ?? false;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function longToNumber(long: Long): number {
  if (long.gt(globalThis.Number.MAX_SAFE_INTEGER)) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  return long.toNumber();
}

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
